import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";


import Machine from "../../models/machine";

const RECORS_PER_SEARCH = 20;

type MachineSelectProps = {
  value: Machine | null;
  onChange: (_: Machine | null) => void;
  disabled?:boolean;
};

const MachineSelect: React.FC<MachineSelectProps> = ({
  value,
  onChange,
  disabled
}) => {
  
  const loadOptions = async (
    s: string,
    currentOpts: readonly (
      | Machine
      | { options: Machine[]; label?: string }
    )[]
  ): Promise<
    Response<Machine, { options: Machine[]; label?: string }, any>
  > => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();


    if (s !== "") {
      additionalParams.set("search", s);
    }

    const dataPaginated = await getList<Machine>(
      "/machines/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: Machine[] = [];
    let count = 0;

    if (dataPaginated.data !== undefined) {
      newOpts = dataPaginated.data.items;
      count = dataPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };
  return (
    <AsyncPaginateBootstrap
      placeholder={"Seleccione una Máquina"}
      onChange={onChange}
      isMulti={false}
      debounceTimeout={300}
      loadOptions={loadOptions}
      getOptionLabel={(option: Machine) => `${option.name} - ${option.deviceIdentifier}`}
      getOptionValue={(option: Machine) => `${option.id}`}
      value={value}
      isDisabled={disabled}
    />
  );
};

export default MachineSelect;
